import React from 'react';
import PropTypes from 'prop-types';

import Date from '../../../../../shared/components/Moment/Date.jsx';

export function Availability(props) {
  const preavis = parseInt(props?.freelance?.preavis ?? 0, 10);
  const date = props?.freelance?.date_available ?? null;

  switch (preavis) {
  case 0: default:
    return 'maintenant';
  case 1:
    return 'dans 1 mois';
  case 2:
    return 'dans 2 mois';
  case 3:
    return 'dans 3 mois';
  case -1:
    return date ? <span>le <Date date={date} /></span> : '';
  }
}

Availability.propTypes = {
  freelance: PropTypes.object.isRequired
};

export default Availability;